<template>
  <b-row class="px-sm-4 px-md-4 px-lg-0 pt-sm-3">
    <b-col cols="12" class="mb-3">
      <PageTitle title="Meios de pagamento" />
    </b-col>
    
    <b-col cols="12" class="mb-4">
      <div >
      <b-button 
        class="mr-3" 
        variant="danger"
        @click="$refs.videoManual.toggleOpen({ 
          url: 'https://www.youtube.com/watch?v=PeBP-BNoiNQ&list=PLW_y7yl6WbLvRvXmlcWDT7-Zi0jR-P721&index=14', 
          title: 'Selecionar produtos' 
        })"
      >
        <i class="fas fa-play mr-1"></i>
        Ver video
      </b-button>
      <a
        class="btn btn-success"
        href="https://api.construp.com.br/assets/Meios de pagamento.pdf"
        target="_blank"
        download
        ><i class="fas fa-file-pdf c-white"></i> Baixar Manual</a
      >
      </div>
    </b-col>
    
    <b-col cols="12" class="mb-4">
      <PlanCard :desativarComissao="desativarComissao" />
    </b-col>

    <!-- <b-col cols="12" class="mb-4">
      <value-addition
        @pageReload="get()">
      </value-addition>  
    </b-col> -->

    <b-col cols="12" sm="12" md="12" lg="6" xl="6" class="mb-4">
      <active-price></active-price>  
    </b-col>

    <b-col cols="12" sm="12" md="12" lg="6" xl="6" class="mb-4">
      <b-card>
        <b-row>
          <b-col cols="6">
            <b-card-title class="fs-32 d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center">
                <span> Pedido mínimo </span>
              </div>
            </b-card-title>
          </b-col>

          <b-col cols="6" class="d-flex align-items-center">
            <b-form-checkbox
              switch
              :checked="purchase.status"
              @change="purchase.status = !purchase.status"
            />
            <span>{{ purchase.status ? 'Ativado' : 'Desativado' }}</span>
          </b-col>
        </b-row>

        <b-card-text v-if="purchase.status">
          <b-row class="d-flex align-items-center justify-content-between">
            <b-col cols="6" class="fs-24">
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text" id="basic-addon1">R$</span>
                </div>
                <b-input 
                  type="number"
                  v-model="purchase.value"  
                  class="form-control" 
                  placeholder="Ex: 100"
                  v-mask="['####']"
                ></b-input>
                <div class="input-group-prepend">
                  <span class="input-group-text" id="basic-addon1">,00</span>
                </div>
              </div>
            </b-col>

          </b-row>
        </b-card-text>

        <b-card-text v-else>
          <p class="marginVelse"></p>
          <br>
        </b-card-text>

        <b-card-text>
          <b-row>
            <b-col cols="12">
              *Habilita o pedido de compra mínima para o cliente no aplicativo.
            </b-col>
          </b-row>
        </b-card-text>

        <b-card-text class="mt-2">
          <b-button
            variant="success"
            block
            @click="minPurchaseSave()"
          >Salvar</b-button>
        </b-card-text>
        
      </b-card>
    </b-col>

    <b-col
      cols="12"
      class="mb-4"
      v-for="(paymentMethod, index) in paymentMethods"
      :key="index"
    >
      <b-overlay rounded="sm">
        <b-card>      
          <b-row>
            <b-col cols="12" sm="12" md="12" lg="6" xl="6">
              <b-row>
                <b-col cols="12">
                  <b-card-title class="fs-32 d-flex align-items-center justify-content-between">
                    <div class="d-flex align-items-center">
                      <span> {{ paymentMethod.name }} </span>
                    </div>
                  </b-card-title> 
                </b-col>
              </b-row>

              <b-row>
                <b-col cols="12" class="d-flex align-items-center">
                  <label class="fs-20">Deseja habilitar esse meio de pagamento?</label>
                  <b-form-checkbox
                    switch
                    class="ml-3"
                    @change="paymentEnable(index, paymentMethod.type)" 
                    :checked="paymentMethod.enabled"
                  />
                  <span> {{ meioPagamento(paymentMethod.enabled, paymentMethod.type) }}</span>
                </b-col>
              </b-row>

              <!-- DESCONTO -->
              <b-row class="mt-1 container">
                <label class="fs-20">Deseja habilitar desconto?</label>
                <b-form-checkbox
                  switch
                  class="ml-3"
                  :checked="paymentMethod.discountEnabled == true"
                  @change="discountEnableFunc(index)"
                />
                <b-col cols="12" md="8" v-if="paymentMethod.discountEnabled == true">
                  <div class="input-group mb-3">
                    <input
                      class="form-control"
                      placeholder="Ex: 10"
                      aria-describedby="discount"
                      type="text"
                      aria-label="deconto em porcentagem"
                      v-model="paymentMethod.discount"
                      v-mask="'##'"
                    >
                    <span
                      v-if="paymentMethod.discount > 0 && paymentMethod.enabled"
                      class="input-group-text"
                      id="discount"
                    >%</span>
                  </div>
                </b-col>
              </b-row>

              <b-row v-if="paymentMethod.type == 5">
                <b-col cols="12">
                  <label class="fs-20">Descrição do pagamento: (Opcional)</label>
                  <input type="text" class="form-control" v-model="paymentMethod.descricao" placeholder="Ex: Pagamento na entrega pix e dinheiro e na loja pix, dinheiro e cartão.">
                </b-col>
              </b-row>

              <b-row class="mt-4" v-if="paymentMethod.type == 3">
                <b-col cols="6" lg="3">
                  <div v-for="(number, index) in 6" :key="`${number}${index}`">
                    {{ number }}x= <strong>2.35%</strong>
                  </div>
                </b-col>

                <b-col cols="6" lg="3">
                  <div v-for="(number, index) in [7, 8, 9, 10, 11, 12]" :key="`${number}${index}`">
                    {{ number }}x= <strong>2.35%</strong>
                  </div>
                </b-col>
              </b-row>

              <b-row>
                <b-col cols="12">
                  <b-button 
                    @click="save(paymentMethod.type, paymentMethod.enabled, paymentMethod.discount, paymentMethod.descricao)"
                    class="mt-2"
                    block
                    variant="success"
                    >Salvar
                  </b-button>
                </b-col>
              </b-row>
            </b-col>

            <b-col cols="12" sm="12" md="12" lg="6" xl="6" v-if="(!desativarComissao) || (paymentMethod.type != 4 && paymentMethod.type != 5)">
              <table class="table table-striped table-bordered">
                <thead>
                  <tr>
                    <th scope="col">Tarifas por transação em seu plano:</th>
                    <th scope="col">Retire seu dinheiro em:</th>
                    <th scope="col" v-if="paymentMethod.information"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <div v-html="paymentMethod.details"></div>
                    </td>
                    <td>
                      <div v-if="paymentMethod.getMoneyInXDays > 0" class="font-weight-bold">{{ paymentMethod.getMoneyInXDays }} dia(s)</div>
                      <div v-else class="font-weight-bold">{{ paymentMethod.getMoneyInXDays }}</div>
                    </td>
                    <td v-if="paymentMethod.information">
                      <div v-html="paymentMethod.information"></div>
                    </td>
                  </tr>
                </tbody>
              </table>

              <div>
                <button class="btn btn-primary btn-block" @click="clean(paymentMethod.type)">
                  EXCLUIR PRODUTOS PARA DESCONTO NESSE MEIO DE PAGAMENTO
                </button>
              </div>
            </b-col>
            
          </b-row>

        </b-card>
      </b-overlay>
    </b-col>

    <b-col v-if="enabledCredit">
      <InstallmentsCard />
    </b-col>

    <b-modal
      id="updateDiscountProduct"
      title="Pagamento por boleto"
      size="xl"
      header-bg-variant="orange"
      header-text-variant="light"
      centered
      hide-footer
    >
      <b-row class="mt-2">
        <b-col cols="12" class="mt-3">
          <label>Buscar produto</label>
        </b-col>
    
        <b-col cols="9">
          <input 
            type="text"
            class="form-control" 
            v-model="product" 
            @keyup.enter="search()"
            placeholder="Nome produto, cód. barras ou marca..."
          >
        </b-col>

        <b-col cols="3">
          <b-button variant="success" @click="search()">Pesquisar</b-button>
          <b-button class="ml-4" variant="warning" @click="clean()">Limpar</b-button>
        </b-col>
        
        <b-col cols="12" class="mt-5">
          <b-table
            striped
            outlined
            hover
            responsive
            :fields="table.headers"
            :items="table.records"
          >
          <template #cell(action)="data">
            <b-button 
              v-if="data.item.paymentType == null"
              @click="setProductDiscount(data.item.id)"
              variant="success"
              v-b-tooltip.hover
              title="Adicionar produto ao desconto"
            >
              <i class="fas fa-plus"></i>
            </b-button>
            <b-button 
              v-else
              @click="setProductDiscount(data.item.id)"
              variant="danger"
              v-b-tooltip.hover
              title="Remover produto do desconto"
            >
              <i class="fas fa-trash"></i>
            </b-button>
          </template>

          <template #cell(photo)="data">
            <img
              :src="linkFotos(data.item.origem) + data.item.photo"
              :alt="data.item.product"
              width="100px"
            />
          </template>

          <template #cell(priceSalesFormat1)="data">
            <span>{{ formatNumber(data.item.priceSalesFormat1) }}</span>
          </template>
          </b-table>
        </b-col>
        <div class="ml-3 mt-5" v-observe-visibility="visibilityChanged">Carregando mais itens..</div>
      </b-row>
    </b-modal>

    <VideoManual ref="videoManual"/>
  </b-row>
</template>

<script>
import { mapActions, mapState } from 'vuex';

import UserTypes from '@/enums/UserTypes';
import TypePermission from '@/enums/Clerk/TypePermission';
import NamePermission from '@/enums/Clerk/NamePermission';
import makeToast from '../../../mixins/makeToast';
import PageTitle from '../../../components/PageTitle.vue';
import Card from './Card.vue';
import PlanCard from './PlanCard.vue';
import InstallmentsCard from './InstallmentsCard.vue';
import PAYMENT_METHODS from 'Enums/PaymentMethods.js';
import ActivePrice from './ActivePrice.vue';
import VideoManual from '@/components/VideoManual.vue';
import ValueAddition from '@/views/lojista/payment-methods/ValueAddition.vue';

export default {
  name: 'PaymentMethodSave',
  mixins: [makeToast],
  components: {
    PageTitle,
    Card,
    PlanCard,
    InstallmentsCard,
    ActivePrice,
    VideoManual,
    ValueAddition
  },
  data() {
     return {
      PAYMENT_METHODS,
      loading: false,
      enabledCredit: false,
      desativarComissao: false,
      fields: {},
      paymentMethods: null,
      purchase: {
        value: 0,
        status: false,
      },
      item: [],
      paymentType:null,
      product:'',
      pagination: {
        currentPage: 1,
        itemsPerPage: 1,
        total: 1,
      },
      table:{
        headers: [
          {
            key: 'index',
            thClass: 'd-none',
            tdClass: 'd-none',
          },
          {
          key: 'action',
          label: 'Ação',
          },
          {
            key: 'photo',
            label: 'Imagem',
          },
          {
            key: 'product',
            label: 'Produto',
          },
          {
            key:'priceSalesFormat1',
            label: 'Preço'
          },
          {
            key: 'codbar',
            label: 'Cod. barras',
          },
          {
            key: 'marca',
            label: 'Marca',
          },
        ],
        records:[]
      },
    };
  },
  computed: {
    ...mapState(['dadosUsuario']),
  },

  created() {
    if(this.dadosUsuario.desativar_comissao && this.dadosUsuario.desativar_comissao) {
      this.desativarComissao = true;
    }

    this.get();
  },

   watch: {
    'pagination.currentPage': function () {
      this.setPaymentType();
    },
  },

  methods: {
    ...mapActions('shopkeeper', [
      'savePaymentMethod',
      'getPaymentMethods',
      'getRemoveDiscountPaymentMethod',
      'saveRemoveDiscountPaymentMethod',
      'saveMinPurchase'
    ]),
    
    get() {
      this.$store.dispatch('startLoader');

      this.getPaymentMethods(this.userTypeId())
        .then((response) => {
          const { data = [] } = response.data || {};
          this.purchase.value = data[0].valueMinPurchase ? data[0].valueMinPurchase : 0;
          this.purchase.status = data[0].statusMin && data[0].statusMin == 1 ? true : false;

          this.paymentMethods = response.data.data;

        })
        .catch(() => {
          this.makeToast('Erro', 'Houve um erro ao trazer os meios de pagamentos', 'danger');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    clean(paymentType = null) {
      if (paymentType) {
        this.paymentType = paymentType;
      }

      this.table.records = [];
      this.pagination.currentPage = 1;
      this.product = '';
      this.setPaymentType();
    },
    search() {
      this.table.records = [];
      this.pagination.currentPage = 1;
      this.setPaymentType();
    },
    setPaymentType() {
      const data = {
        userId: this.userTypeId(),
        productName: this.product,
        paymentType: this.paymentType,
        isActive: this.isActive,
        currentPage: this.pagination.currentPage
      }

      this.$store.dispatch('startLoader');
      this.getRemoveDiscountPaymentMethod(data)
      .then((response) => {
        const { perPage, total } = response.data.data || {};
        this.pagination.itemsPerPage = perPage || 15;
        this.pagination.total = total;
        this.table.records.push(...response.data.data.data);

        this.$bvModal.show('updateDiscountProduct');
      })
      .finally(() => {
        this.$store.dispatch('endLoader');
      });
    },
    setProductDiscount(id) {
      const data = {
        id: id,
        paymentType: this.paymentType
      }

      this.$store.dispatch('startLoader');
      this.saveRemoveDiscountPaymentMethod(data)
      .then((response) => {
        if(response.data.error == true) {
          this.makeToast('Erro', 'Erro ao atualizar produto!', 'danger');
          return;  
        }

        this.makeToast('Sucesso', response.data.message, 'success');
        this.search();        
      })
      .finally(() => {
        this.$store.dispatch('endLoader');
      });
    },
    linkFotos(origem) {
      if(origem == 'Belenus' || origem == 'fixadores') {
        return 'https://storage.googleapis.com/fotos-prd/';
      } else {
        return process.env.VUE_APP_FOTOS_URL;
      }
    },
    formatNumber(number) {
      return Intl.NumberFormat('pt-BR', {
        currency: 'BRL',
        style: 'currency',
      }).format(number);
    },
    paymentEnable(index, type) {
      this.paymentMethods[index].enabled = !this.paymentMethods[index].enabled;

      this.enabledCredit = false;
      if(this.paymentMethods[index].enabled == true && type == 3) {
        this.enabledCredit = true;
      }

      if(this.paymentMethods[index].enabled == false) {
        this.paymentMethods[index].discountEnabled = false;
        this.paymentMethods[index].discount = 0;
      }
    },
    meioPagamento(status, type) {
      if(type == 3 && status == true) {
        this.enabledCredit = true;
      }

      return status == true ? 'Ativado' : 'Desativado';
    },
    discountEnableFunc(index) {
      this.paymentMethods[index].discountEnabled = !this.paymentMethods[index].discountEnabled;

      if(this.paymentMethods[index].discountEnabled == false) {
        this.paymentMethods[index].discount = 0;
      }
    },
    save(type, enabled = false, discount = 0, descricao = '') {
      const request = {
        userId: this.userTypeId(),
        type,
        enabled,
        discount,
        descricao
      };

      this.$store.dispatch('startLoader');
      this.savePaymentMethod(request)
        .then((response) => {
          if(response.data.error == true) {
            this.makeToast('Erro', response.data.message, 'danger');   
          } else {
            this.makeToast('Sucesso', response.data.message, 'success');
          }
          this.get();
          this.$root.$emit('valid-available-app');
        })
        .catch(() => {
          this.makeToast('Erro', 'Houve um erro ao atualizar o meio de pagamento', 'danger');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    minPurchaseSave(){
      if(this.purchase.value == 0 && this.purchase.status) {
        this.makeToast('Erro','Favor inserir um valor maior que 0','danger');
      }

      const request = {
        "lojista_id": this.userTypeId(),
        "value": this.purchase.value,
        "status": this.purchase.status
      }

      this.saveMinPurchase(request)
        .then((response) => {
          if (response.data.data) {
            this.makeToast('Sucesso','Meio de pagamento atualizado com sucesso');
          }
        })
        .catch(() => {
          this.makeToast('Erro','Houve um erro ao trazer o valor minimo de compra','danger');
        });
    },
    userTypeId() {
      return this.$route.meta.userType == UserTypes.BALCONISTA
        ? this.dadosUsuario.construp_user_id
        : this.dadosUsuario.id;
    },
    whatClerkPermission() {
      if (this.$route.meta.userType == UserTypes.BALCONISTA) {
        const permissionClerk = JSON.parse(
          localStorage.getItem('permissionClerk')
        );
        const permission = permissionClerk.find(
          (element) => element.name == NamePermission.MEIO_PAGAMENTO
        );

        if (
          this.$route.meta.userType == UserTypes.BALCONISTA &&
          permission.type == TypePermission.BALCONISTA
        ) {
          return true;
        }
      }
      return false;
    },
    visibilityChanged(isVisible) {
      if (!isVisible || this.loading == true) return;
      const totalPage = this.pagination.total / this.pagination.itemsPerPage;
      if (this.pagination.currentPage >= Math.ceil(totalPage)) return;
      this.pagination.currentPage = this.pagination.currentPage + 1;
    },
  },
};
</script>

<style scoped>
.marginVelse {
  margin-bottom: 14px;
}
</style>